export enum OrderDeliveryMetrics {
  SUM_GMV = 'SUM_GMV',
  COUNT_ORDER = 'COUNT_ORDER',
  AVG_GMV = 'AVG_GMV',
  COUNT_USER = 'COUNT_USER',
  AVG_RATING = 'AVG_RATING',
  AVG_USER_PER_STORE = 'AVG_USER_PER_STORE',
  AVG_GMV_PER_STORE = 'AVG_GMV_PER_STORE',
  AVG_FIRST_ORDER_PER_STORE = 'AVG_FIRST_ORDER_PER_STORE',
  COUNT_FIRST_ORDER = 'COUNT_FIRST_ORDER',
  MAX_UPDATED_AT_DATE_TIME_UTC = 'MAX_UPDATED_AT_DATE_TIME_UTC',
}

export enum OrderDeliveryGroupBys {
  DATE_PT = 'DATE_PT',
  WEEK_SUN_PT = 'WEEK_SUN_PT',
  MONTH_PT = 'MONTH_PT',
  ORDER_SOURCE = 'ORDER_SOURCE',
  PICKUP = 'PICKUP',
  ALCOHOL = 'ALCOHOL',
  EXPRESS = 'EXPRESS',
  LOYALTY = 'LOYALTY',
  EBT = 'EBT',
  FIRST_ORDER = 'FIRST_ORDER',
  VIRTUAL_WAREHOUSE = 'VIRTUAL_WAREHOUSE',
  WAREHOUSE_LOCATION = 'WAREHOUSE_LOCATION',
  WAREHOUSE_LOCATION_STATE = 'WAREHOUSE_LOCATION_STATE',
  PARTNER_GEO_DIVISION = 'PARTNER_GEO_DIVISION',
  ORDER_CURRENCY = 'ORDER_CURRENCY',
  REGION = 'REGION',
  FULFILLMENT_TYPE = 'FULFILLMENT_TYPE',
}
